import { ark } from '@ark-ui/react';
import { styled, button, type ComponentProps } from '@terra/ui-styled-system';

export const Button = styled(ark.button, button);
export type ButtonStyledProps = ComponentProps<typeof Button>;
export type ButtonSize = Extract<
  NonNullable<ButtonStyledProps['size']>,
  '2xs' | 'xs' | 'sm' | 'md'
>;
